/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");

Vue.component(
    'contact-form-component',
    require('./Components/ContactFormComponent.vue').default
);

//link lead-in section selection to modal
$(document).ready(function() {
    $('#passion-lead-in').change(function() {
        window.app.$refs.contactForm.updatePassion($(this).val());
        $('#contact-form-modal').modal('show');
    });
});

// get scroll direction
let currentScroll = 0;

// sticky elements for scrolling
let stickyHeader = document.querySelector('.sticky-header');
let stickyFooter = document.querySelector('.sticky-footer-scroll');

//sticky header logic
function showStickyHeader(scrollAmount){
    scrollAmount > 0 ? stickyHeader.classList.remove('d-none') : stickyHeader.classList.add('d-none');
    return scrollAmount;
}

function openStickyHeader(scrollAmount){
    currentScroll > scrollAmount ? stickyHeader.classList.add('scrollUpOpen') : stickyHeader.classList.remove('scrollUpOpen');
}

//sticky footer logic
function showStickyFooter(scrollAmount){
    // calculate the y stop position
    let baseFooter = document.querySelector('.sticky-footer');
    let bodyRect = document.body.getBoundingClientRect();
    let stickyFooterBounds = baseFooter.getBoundingClientRect();
    let offset = stickyFooterBounds.top - bodyRect.top;
    scrollAmount < offset && currentScroll < offset-window.innerHeight+stickyFooter.offsetHeight ? stickyFooter.classList.remove('d-none') : stickyFooter.classList.add('d-none');
    return scrollAmount;
}

function openStickyFooter(scrollAmount){
    currentScroll < scrollAmount ? stickyFooter.classList.add('scrollDownOpen') : stickyFooter.classList.remove('scrollDownOpen');
}

window.addEventListener('scroll', (e) => {
    openStickyHeader(showStickyHeader($(window).scrollTop()));
    openStickyFooter(showStickyFooter($(window).scrollTop()));
    currentScroll = $(window).scrollTop();
}); 


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component("example-component", require("./components/ExampleComponent.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.app = new Vue({
	el: "#app",
});